import { render, staticRenderFns } from "./ChatHelpModel.vue?vue&type=template&id=15730420"
import script from "./ChatHelpModel.vue?vue&type=script&lang=js"
export * from "./ChatHelpModel.vue?vue&type=script&lang=js"
import style0 from "./ChatHelpModel.vue?vue&type=style&index=0&id=15730420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports